module.exports = __webpack_public_path__ + "static/media/product4.3ec5452c.jpg";